/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/brace-style */
/* istanbul ignore file */
import { Box, Breadcrumbs, FormHelperText, Grid, Link, Modal, TextField, Typography } from '@mui/material'
import React, { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import BackButton from '../../../components/BackButton'
import { Button } from '../../../components/Button'
import Water_Merlin from '../../../assets/devices/WaterMerlinNBOT.svg'
import CloseIcon from '@mui/icons-material/Close'
import LanguageStrings from '../../../i18n/locales'
import '../../device-details/components/EditAsset.css'
import DeviceUtil from '../../../utils/DeviceUtil'
import { useSelector, connect } from 'react-redux'
import { type ConnectedProps } from 'react-redux'
import { type RootState } from '../../../store'
import Q600 from '../../../assets/devices/Q600.svg'
import NXS from '../../../assets/devices/NXCM_AC250.svg'
import Eletric from '../../../assets/devices/A4R.svg'
import DefaultImage from '../../../assets/devices/No-Image-Placeholder.svg'
import HBG3 from '../../../assets/devices/HBG3.svg'
import { editAssetSummaryInfo, getAllTagsByIDInfo } from '../redux/actionCreator'
import { type editSummaryReq } from '../services/editAssetSummaryService'
import { type EditAssetSummaryInfo } from '../redux/editAssetSummaryInfoSlice'
import { useAuth } from 'react-oidc-context'
import { isValidName, isValidIp, isValidPort } from '../../../utils/validator'
import { GenericDropdown, type Option } from '../../../components/GenericDropdown'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { styled } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs, { type Dayjs } from 'dayjs'
const EditAssetSummaryStrings = LanguageStrings().AssetConfigurationStrings.components.EditAssetSummaryDetailsComponents

const assetValuesStyles = {
  display: 'block',
  margin: '30px 0px'
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: '#272727',
  fontFamily: 'Honeywell Sans Web',
  p: 4,
  borderRadius: '5px'
}

function getDeviceImage (device: any): string {
  if (device != null) {
    if (DeviceUtil.getDeviceTypeByName(device)?.isGas === true) {
      return NXS
    } else if (DeviceUtil.getDeviceTypeByName(device)?.isElectric === true) {
      return Eletric
    } else if (DeviceUtil.getDeviceTypeByName(device)?.isWater === true) {
      if (DeviceUtil.getDeviceTypeByName(device)?.isQ600 === true) {
        return Q600
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isHBG3 === true) {
        return HBG3
      }
      return Water_Merlin
    }
  }
  return DefaultImage
}

const EditAssetSummary = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const [showEditSummaryModal, setshowEditSummaryModal] = React.useState(false)
  const AssetSummaryData = useSelector((state: RootState) => state.assetById?.assetData)
  const tagUpdateHttpStatus = useSelector((state: RootState) => state.EditAssetSummaryInfoSlice.httpStatus)
  const assetStateTypeData = useSelector((state: RootState) => state.AssetStatesTypeData?.AssetStatesTypeData)
  const AllTagsData: any = useSelector((state: RootState) => state.getAllTags?.tags)
  const AllTagsDataLoading: any = useSelector((state: RootState) => state.getAllTags?.isLoading)
  const [StateSucessModal, setStateSucessModal] = React.useState<boolean>(false)
  const [reqError, setReqError] = React.useState<boolean>(false)
  const [AssetStateTypeOptions, setAssetStateTypeOptions] = React.useState<Option[]>([])
  const [ip, setIp] = React.useState(AssetSummaryData?.ip_address ?? '')
  const [port, setPort] = React.useState(AssetSummaryData?.port ?? '')
  const [ipError, setIpError] = React.useState('')
  const [portError, setPortError] = React.useState('')
  const auth = useAuth()
  const defaultDate = dayjs(new Date())
  const [isDateChanged, setDateChanged] = React.useState(false)
  const [installationStateDate, setInstallationStateDate] = React.useState<Dayjs | null | undefined>(defaultDate)
  const [DisplayTag, setDisplayTag] = React.useState<boolean>(false)
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)

  let paramAssetId = sessionStorage.getItem('paramAssetId')
  if (paramAssetId === null) {
    paramAssetId = ''
  }

  function useOutsideAlerter (ref: any) {
    React.useEffect(() => {
      function handleClickOutside (event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDisplayTag(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  const oldintialState = {
    tag: [{ name: AssetSummaryData?.tag[0]?.name ? AssetSummaryData?.tag[0]?.name : '' }],
    state: AssetSummaryData?.asset_state,
    installDate: installationStateDate,
    ip: {
      ip_address: AssetSummaryData?.ip_address ? AssetSummaryData?.ip_address : '',
      port: AssetSummaryData?.port ? AssetSummaryData?.port : ''
    },
    confirmedStateUpdate: true
  }

  const intialState = {
    tag: [{ name: AssetSummaryData?.tag[0]?.name ? AssetSummaryData?.tag[0]?.name : '' }],
    state: AssetSummaryData?.asset_state,
    installDate: installationStateDate,
    ip: {
      ip_address: ip ?? '',
      port: port ?? ''
    },
    confirmedStateUpdate: true
  }

  const WhiteDatePicker = styled(DatePicker)({
    '& input': {
      color: '#b8b6b6',
      padding: '10px 14px'
    }
  })

  const CustomLocalizationProviderWrapper = styled('div')({
    backgroundColor: '#5c5b5bdd',
    borderRadius: '4px'
  })

  React.useEffect(() => {
    props.getAllTagsByIDInfo('')
  }, [])

  React.useEffect(() => {
    if (assetStateTypeData !== null && assetStateTypeData?.length > 0) {
      const assetStateTypes: Option[] = []
      assetStateTypeData?.forEach((assetState: any) => {
        assetStateTypes.push({
          value: assetState.asset_state_type_id,
          label: assetState.asset_state_type_name
        })
      })
      setAssetStateTypeOptions(assetStateTypes)
    }
  }, [assetStateTypeData])

  const assetId = paramAssetId ?? ''

  const [addState, dispatchState] = React.useReducer((curVal: any, newVal: any) => ({ ...curVal, ...newVal }), intialState)

  const closeAddModal = () => {
    setshowEditSummaryModal(false)
  }

  const handleSelecttags = (e: any) => {
    setDisplayTag(true)
    props.getAllTagsByIDInfo(e.target.value)
    dispatchState({ ...addState, tag: [{ name: e.target.value }] })
  }

  const handleIpChange = (e: any): void => {
    if (e.target.value === '') {
      setIpError('')
      setIp('')
    } else if (!isValidIp(e.target.value)) {
      setIpError('Invalid IP')
      setIp(e.target.value)
    } else {
      setIpError('')
      setIp(e.target.value)
    }
    dispatchState({ ...addState, ip: { ip_address: e.target.value, port } })
  }

  const handlePortChange = (e: any): void => {
    if (e.target.value === '') {
      setPortError('')
      setPort('')
    } else if (!isValidPort(e.target.value)) {
      setPortError('Invalid Port')
      setPort(e.target.value)
    } else {
      setPortError('')
      setPort(e.target.value)
    }
    dispatchState({ ...addState, ip: { ip_address: ip, port: e.target.value } })
  }

  const handleConfirmUpdate = () => {
    props.editAssetSummaryInfo(addState, assetId ?? '', auth.user?.profile.customer as string)
    setshowEditSummaryModal(false)
    setStateSucessModal(true)
  }

  const closeStateChangeModal = () => {
    setStateSucessModal(false)
    navigate('/devicedetails')
  }

  const handleChooseState = (name: string, value: string) => {
    const AssetStateTypeIdName = assetStateTypeData.find((a: { asset_state_type_id: string }) => a.asset_state_type_id === value).asset_state_type_name
    dispatchState({ ...addState, state: AssetStateTypeIdName })
  }

  const handleInstallationDate = (val: any) => {
    setInstallationStateDate(val)
    dispatchState({ ...addState, installDate: val })
  }

  const checkIfEditInfoValid = (): boolean => {
    return (JSON.stringify(oldintialState) === JSON.stringify(addState)) || ipError !== '' || portError !== ''
  }

  const validateFields = (): void => {
    if (addState.tag[0]?.name === undefined || addState.tag[0]?.name !== undefined) {
      if (addState.tag[0].name) {
        if (!isValidName(addState.tag[0].name)) {
          setReqError(true)
          return
        }
      }
      if (addState.ip.ip_address) {
        if (!isValidIp(addState.ip.ip_address)) {
          setIpError('Invalid IP')
          return
        }
      }
      if (addState.ip.port) {
        if (!isValidPort(addState.ip.port)) {
          setPortError('Invalid Port')
          return
        }
      }
      if (isDateChanged) {
        setDateChanged(true)
      }
      setshowEditSummaryModal(true)
    }
    else {
      setReqError(true)
    }
  }

  return (
    <>
      <div role='presentation' data-testid='breadcrumbs' style={{ width: '100%' }} >
        <Breadcrumbs aria-label='breadcrumb' sx={{ color: '#f0f0f0', fontSize: '12px', marginBottom: '14px', fontFamily: 'Honeywell Sans Web', marginTop: '12px' }}>
          <Link color='inherit' className='breadcrumbAssetMgmt' style={{ textDecoration: 'none', fontSize: '.875rem' }} data-testid='device-management-breadcrumb' onClick={() => { navigate('/isense') }} >
            {EditAssetSummaryStrings.AMI_Operations_Hub}
          </Link>
          <Link data-testid='asset-list' style={{ cursor: 'pointer', color: '#F0F0F0', textDecoration: 'none', fontSize: '.875rem' }} color='inherit' onClick={() => { navigate('/asset-list') }}>
            {EditAssetSummaryStrings.Asset_list}
          </Link>
          <Link data-testid='asset-serial' style={{ cursor: 'pointer', color: '#F0F0F0', textDecoration: 'none', fontSize: '.875rem' }} color='inherit' onClick={() => { navigate('/devicedetails') }}>
            {AssetSummaryData?.comm_mod_serial}
          </Link>
          <Link data-testid='asset-summary' style={{ cursor: 'pointer', color: '#F0F0F0', textDecoration: 'none', fontSize: '.875rem' }} color='inherit' onClick={() => { navigate('/edit-asset-summary') }}>
            {EditAssetSummaryStrings.Edit_Asset_summary}
          </Link>
        </Breadcrumbs>
      </div>
      <div className='topUtilityBar' style={{ marginBottom: '30px', marginRight: '0px' }}>
        <BackButton dataTestId='back-arrow' onclick={() => { navigate('/devicedetails') }} />
        <span id='componentTitle' data-testid='asset-Summary-title' >{EditAssetSummaryStrings.Edit_Asset_summary}</span>
      </div>
      <div className='edit-container' style={{
        backgroundColor: '#303030',
        border: '1px solid #000',
        margin: '20px 10px',
        padding: '20px',
        borderRadius: '4px'
      }}>
        <Grid container style={{ paddingTop: '20px' }}>
          <Grid container>
            <h4 data-testid='box-heading'>{EditAssetSummaryStrings.title}</h4>
          </Grid>
          <span style={assetValuesStyles}></span>
          <Grid xs={12} sm={2}>
            <div
              style={{
                padding: '10px',
                backgroundColor: 'white',
                height: 'fit-content',
                borderRadius: '10px',
                width: 'fit-content',
                textAlign: 'center'
              }}
            >
              <img
                src={getDeviceImage(AssetSummaryData?.device_type)}
                style={{ width: '150px', height: 'auto' }}
              />
            </div>
          </Grid>
          <Grid container xs={12} sm={10}>
            <Grid container className='assetSummaryRow'>
              <Grid item xs={12} sm={3}>
                <Grid>{EditAssetSummaryStrings.Asset_Type}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  {AssetSummaryData?.device_type}
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Asset_Configuration}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  Honeynell E17 CPF40
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Meter_Serial_Number}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  {AssetSummaryData?.serial_number}
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Meter_Date_of_Shipment}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  -----
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
              <Grid style={{ marginBottom: '5px' }} data-testid="state-info"> {EditAssetSummaryStrings.State}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  <GenericDropdown dataTestId='category' allowInput={true} width={225} options={AssetStateTypeOptions} value={addState.asset_state_type_name} onChange={(e) => handleChooseState('assetStateType', e.target.value)} label={''} />
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.ClipOn_Serial_Number}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  {AssetSummaryData?.comm_mod_serial}
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Meter_Date_of_Expiry}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  ----
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.IP_Port}</Grid>
                <Grid container style={{ color: '#64C3FF' }}>
                  <Grid item xs={12} sm={5} style={{
                    margin: '10px 10px 0px 0px'
                  }}>
                    <TextField id='outlined-basic' label='' size='small' variant='outlined' onChange={handleIpChange} value={ip}
                      sx={{
                        input: {
                          color: '#fff',
                          '&::placeholder': {
                            opacity: 1
                          }
                        },
                        label: { color: '#fff', fontSize: '12px' },
                        backgroundColor: '#645e5e'
                      }}
                    />
                    {ipError && addState?.ip.ip_address !== '' && !isValidIp(addState?.ip.ip_address) && <FormHelperText style={{ maxWidth: 269 }} className='errorColor'>Invalid IP Address</FormHelperText>}
                  </Grid>
                  <Grid item xs={12} sm={5} style={{
                    margin: '10px 10px 0px 0px'
                  }}>
                    <TextField id='outlined-basic' inputProps={{ maxLength: 5 }} label='' size='small' variant='outlined' onChange={handlePortChange} value={port}
                      sx={{
                        input: {
                          color: '#fff',
                          '&::placeholder': {
                            opacity: 1
                          }
                        },
                        label: { color: '#fff', fontSize: '12px' },
                        backgroundColor: '#645e5e'
                      }} />
                    {portError && addState?.ip.port !== '' && !isValidPort(addState?.ip.ip_address) && <FormHelperText style={{ maxWidth: 269 }} className='errorColor'>Invalid Port</FormHelperText>}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid>{EditAssetSummaryStrings.Year_of_Certification}</Grid>
                <Grid>-----</Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Firmware_Version}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  None
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Remaining_Battery_Percentage}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  {(AssetSummaryData?.rem_bat_percent != null) ? AssetSummaryData?.rem_bat_percent?.toString() : 'Not Available'}
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Tag}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  <div className='tag-Update'>
                    <TextField
                      style={{
                        color: '#fff',
                        marginTop: '10px',
                        width: '100%',
                        backgroundColor: '#645e5e'
                      }}
                      autoComplete='off'
                      size='small'
                      id='outlined-textarea'
                      placeholder='Search Tag'
                      value={addState.tag[0].name}
                      inputProps={{ maxLength: 20 }}
                      onChange={(e: any) => handleSelecttags(e)}
                      sx={{
                        input: {
                          color: '#fff',
                          '&::placeholder': {
                            opacity: 1
                          }
                        },
                        label: { color: '#fff', fontSize: '12px' }
                      }}
                    />
                    {DisplayTag && AllTagsData?.length > 0 && !AllTagsDataLoading && (
                      <div ref={wrapperRef} className='list'>
                        {AllTagsData.map((item: any, index: any) => (
                          <div
                            key={item.id}
                            onClick={() => {
                              dispatchState({ ...addState, tag: [{ name: item.name }] })
                              setDisplayTag(false)
                            }}
                            className='list-item'
                          >
                            {item.name}
                          </div>
                        ))}
                      </div>
                    )}
                    {reqError && addState.tag[0].name !== '' && !isValidName(addState?.tag[0]?.name) && <FormHelperText style={{ maxWidth: 269 }} className='errorColor'>Invalid Tag Name</FormHelperText>}
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid>{EditAssetSummaryStrings.Installation_Date}</Grid>
                <Grid>
                  <CustomLocalizationProviderWrapper>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <WhiteDatePicker
                        defaultValue={defaultDate}
                        slotProps={{ textField: { fullWidth: true } }}
                        disableFuture
                        value={addState.installDate}
                        onAccept={(val: any) => { handleInstallationDate(dayjs(val))
                          setDateChanged(true) }}
                      />
                    </LocalizationProvider>
                  </CustomLocalizationProviderWrapper>
                </Grid>
                <span style={assetValuesStyles}></span>
                <Grid>{EditAssetSummaryStrings.Batch}</Grid>
                <Grid style={{ color: '#64C3FF' }}>
                  ----
                </Grid>
              </Grid>
            </Grid>
            <Grid
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                paddingTop: '20px',
                paddingBottom: '20px'
              }}
              container
            >
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Modal className='Edit-AssetSummary-Modal' open={showEditSummaryModal} onClose={() => { closeAddModal() }}>
        <Box sx={modalStyle}>
          <div className='title'>
            <Typography id='modal-modal-title' variant='h6' component='h2'>
              {EditAssetSummaryStrings.Update_Asset_Summary}
            </Typography>
            <CloseIcon data-testid='Close-Button-Model'
              style={{ cursor: 'pointer' }}
              onClick={() => { closeAddModal() }}
            />
          </div>
          <Typography id='modal-modal-description' sx={{ mt: 2 }}>
            {EditAssetSummaryStrings.Confirm_message} {AssetSummaryData?.comm_mod_serial}?
          </Typography>
          <div className='add-modal-button-container'>
            <Button data-testid='cancel-edit-summary' className='can-btn-asset'
              onClick={() => { closeAddModal() }} >
              Cancel
            </Button>
            <Button data-testid='edit-asset' className='btn-asset'
              onClick={handleConfirmUpdate} >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
      {tagUpdateHttpStatus && tagUpdateHttpStatus !== null
        ? <div>
          <Modal className='state-update-modal' open={StateSucessModal} onClose={() => { closeStateChangeModal() }}>
            <Box sx={modalStyle}>
              <div className='title'>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={10}>
                    <Typography id='modal-modal-title' variant='h6' component='h2'>
                      Asset Summary Status
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <CloseIcon style={{ cursor: 'pointer' }} data-testid='close-button' onClick={() => { closeStateChangeModal() }} />
                  </Grid>
                </Grid>
              </div>
              <div className='state-div'>
                <h5>{tagUpdateHttpStatus === 200 ? EditAssetSummaryStrings.SucessResponce : tagUpdateHttpStatus === 400 ? EditAssetSummaryStrings.BadRequest : tagUpdateHttpStatus === 404 ? EditAssetSummaryStrings.NotFound : EditAssetSummaryStrings.BadRequest}</h5>
              </div>
              <div className='add-modal-button-container' style={{ float: 'right' }}>
                <Button data-testid='cancel-btn-id' className='can-btn-asset'
                  onClick={() => { closeStateChangeModal() }} >
                  ok
                </Button>
              </div>
            </Box>
          </Modal>
        </div>
        : ''
      }
      <div className='state-button-container state-update'>
        <Button dataTestId='cancel-btn-id' className='can-btn-asset'
          onClick={() => { navigate('/devicedetails') }} >
          Cancel
        </Button>
        <Button dataTestId='next-btn-select' className='update-btn' primaryColor={checkIfEditInfoValid() && !isDateChanged ? '#B0B0B0' : undefined}
          disabled={checkIfEditInfoValid() && !isDateChanged}
          onClick={() => { validateFields() }}>
          Update
        </Button>
      </div>
    </>
  )
}

interface DispatchToProps {
  editAssetSummaryInfo: (editSummaryParamter: editSummaryReq, assetId: string, tenantId: string) => void
  getAllTagsByIDInfo: (search: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  editAssetSummaryInfo: (editSummaryParamter: editSummaryReq, assetId: string, tenantId: string) => dispatch(editAssetSummaryInfo(editSummaryParamter, assetId, tenantId)),
  getAllTagsByIDInfo: (search: string) => dispatch(getAllTagsByIDInfo(search))
})

interface StateToProps {
  editSummary: EditAssetSummaryInfo
}

const mapStateToProps = (state: RootState): StateToProps => ({
  editSummary: state.EditAssetSummaryInfoSlice
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(EditAssetSummary)
